import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import productAction from 'actions/Product';
import productsStore from 'stores/new/Products';
import SliderProducts from 'components/Home/SliderProductsBanner/SliderProducts';
import Error500 from 'components/Error500';
import PubSub from 'services/PubSub';
import CMSService from 'services/CMS';
import { actionsType, ecommerce } from 'config/constants';
import RenderService from 'services/Render'
import SalesChannel from 'services/SalesChannel'
import FavoritesActions from 'actions/Favorites'
import ProductFactory from 'factories/Products'

let actions = [];

const getInitialState = (options) => {
    const data = RenderService.getRenderData();

    if(!(data && data.products)) return {};
    const id = options.collections;
    const salesChannel = SalesChannel.getSalesChannel();
    const productsData = data.products[`/busca?fq=${id}&sc=${salesChannel}`];
    const products = productsData ? productsData.data.map(product => ProductFactory.create(product)) : [];

    return {
        products
    }
}

const SliderProductsContainer = (props) => {
    const { options, title, listTitle, store, notPDP, minProds, callbackNotProducts, tab, campaignData, newProductShelf, stockOnly} = props;
    const initialState = getInitialState(options);
    const [products, setProducts] = useState(initialState.products || []);
    const [isError, setError] = useState(false);

    const [position, setPosition] = useState(options ? options.position : 0);
    const id = options.collections;
    const filter = options.filter;
    let indexTab = tab ? tab : 0;

    useEffect(() => {
        setPosition(0)
    }, [props.tab])

    useEffect(() => {
        let prods = store.products.get(id);

        if(prods && prods.toList){
            prods = prods.toList().toArray();

            const min = minProds ? minProds : 1;
            if((prods.length <= 1) || (prods.length < min)) {
                if(callbackNotProducts){
                    callbackNotProducts(false);
                } else {
                    setError(false);
                }
            } else {
                if(callbackNotProducts){
                    callbackNotProducts(true);
                }
                const _products = newProductShelf ? prods.slice(0, 5) : prods;
                
                if(stockOnly) {
                    const stock = _products && _products.filter((product) => ProductFactory.hasStock(product.items ? product.items[0] : null));
                
                    setProducts(stock);
                } else {

                    setProducts(_products);
                }
            }
        } else {
            setProducts([])
        }
    }, [store]);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            setProducts([]);
            getContent();
        }));
        FavoritesActions.getFavorites(false);

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    useEffect(() => {
        getContent();
    }, [campaignData]);

    const getContent = () => {
        const validSource = ecommerce.whiteLabel ? CMSService.validSellerItem(filter) : CMSService.validSCItem(filter)

        if(filter && !validSource){
            callbackNotProducts(false);
        }

        if(!filter || validSource){
            productAction.getProductsCollection(id, campaignData && campaignData.campaign, campaignData && campaignData.filter);
        }

    };

    if(indexTab === 0 || indexTab > 0){
        let count = position;
        if (products.length) {
            products.map(product => {

                product.pos = count;
                count++;

                return product;
            });
        }
    }else{
        let count = (position - 1) * 12;
        if (products.length) {
            products.map(product => {

                product.pos = count;
                count++;

                return product;
            });
        }
    }

    if(isError) return <Error500 />;

    return <SliderProducts title={title} products={products} isLoading={!products.length} listTitle={listTitle} notPDP={notPDP} newProductShelf={newProductShelf}/>;
};

SliderProductsContainer.propTypes = {
    settings: PropTypes.object,
    title: PropTypes.string,
    listTitle: PropTypes.string,
    productOptions: PropTypes.object,
    options: PropTypes.object,
    callbackNotProducts: PropTypes.func,
    store : PropTypes.object,
    notPDP: PropTypes.bool,
    minProds: PropTypes.number,
    campaignData: PropTypes.object,
    newProductShelf: PropTypes.bool
};

export default productsStore.wrapConsumer(SliderProductsContainer);
